<div class="a00140">
    <a href="{{ href }}" target="{{ target }}">
        <ng-content></ng-content>
    </a>
</div>
